import CountUpNumber from './CountUpNumber';
import type { BentoStatCardData } from './data';

interface BentoStatCardProps {
  data: BentoStatCardData;
}

export default function BentoStatCard({ data }: BentoStatCardProps) {
  return (
    <article className="flex flex-col rounded-3xl bg-primary-50 p-7 md:p-8">
      <div className={data.iconPosition === 'right' ? 'flex justify-end' : 'flex justify-start'}>
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50 text-primary-600">
          <i className={`${data.icon} text-xl`}></i>
        </span>
      </div>

      <div className="mt-5 flex items-baseline font-heading font-bold leading-none text-primary-600">
        <CountUpNumber value={Number(data.value)} duration={2000} className="text-6xl md:text-7xl" />
        <span className="text-3xl md:text-4xl">{data.suffix}</span>
      </div>

      <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 md:text-xl">
        {data.heading}
      </h3>

      <p className="mt-3 text-sm leading-relaxed text-foreground-600">{data.description}</p>

      <div className="mt-6 flex items-center gap-4 rounded-2xl bg-primary-100/70 px-5 py-4 md:mt-auto">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-primary-600">
          <i className={`${data.footerIcon} text-xl`}></i>
        </span>
        <div className="text-sm font-medium leading-snug text-foreground-800">
          {data.footerLines.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </div>
      </div>
    </article>
  );
}